import isIP from 'validator/lib/isIP';
import isFQDN from 'validator/lib/isFQDN';
export const validateEnrichInput = (data) => {
  //lookup PADNS validation, difference to Enrich validation is
  //wildcard (*) is allowed in PADNS lookup, but not in Enrichment

  //this regex is what we think a valid domain looks like
  const domainRegex = new RegExp(/^([a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+.*)$/gi);

  if (data) {
    let sanitizedData = data
      ?.replaceAll('[', '')
      ?.replaceAll(']', '')
      ?.trim()
      ?.replaceAll(' ', '')
      ?.replaceAll('./', '.');
    if (sanitizedData?.toString()?.startsWith('http://')) {
      sanitizedData = sanitizedData?.replace('http://', '');
    }
    if (sanitizedData?.toString()?.startsWith('https://')) {
      sanitizedData = sanitizedData?.replace('https://', '');
    }
    if (sanitizedData?.toString()?.startsWith('www')) {
      sanitizedData = sanitizedData?.replace('www.', '');
    }
    if (
      (isIP(sanitizedData) && !sanitizedData?.includes(':')) ||
      isFQDN(sanitizedData)
    ) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
};
